import { useMemo } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { useEditCanvasStore } from '../../store';
import { useLayerCommands } from '../commands/hooks/useLayerCommands';

export function useLayerShortcuts() {
  const { onMoveBack, onMoveForward, onSendToBack, onSendToFront } = useLayerCommands();
  const readOnly = useEditCanvasStore((s) => s.readOnly);

  const hotkeyOptions = useMemo(() => ({ enabled: !readOnly, preventDefault: true }), [readOnly]);

  // Move Forward: Cmd+] (Mac) / Ctrl+] (Win)
  useHotkeys('meta+],ctrl+]', onMoveForward, hotkeyOptions, [onMoveForward]);

  // Move Back: Cmd+[ (Mac) / Ctrl+[ (Win)
  useHotkeys('meta+[,ctrl+[', onMoveBack, hotkeyOptions, [onMoveBack]);

  // Send to Front: Cmd+Option+] (Mac) / Ctrl+Shift+] (Win)
  // Use "bracketright/bracketleft" so the library matches on e.code (physical key)
  // instead of e.key, which gets remapped by Option/Shift to a special character.
  useHotkeys('meta+alt+bracketright,ctrl+shift+bracketright', onSendToFront, hotkeyOptions, [onSendToFront]);

  // Send to Back: Cmd+Option+[ (Mac) / Ctrl+Shift+[ (Win)
  useHotkeys('meta+alt+bracketleft,ctrl+shift+bracketleft', onSendToBack, hotkeyOptions, [onSendToBack]);
}
